module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAqUlEQVQ4y2NgGBzAdO1/YvAdRX8UjGIAm+XK/y1twf+fHBD6v3OZ/v/cimSwGLIB6ADFgPaOwP//LzL8D88qgmvIKU/+75FYQ5wLXh3h+39+iyJcsWt8Hdg1zw8J/HeKbSDsApABV7fLoBgA0gzCIDZBF8C8kFmaBjekpCYOxQt4XQAKsN5uX7CNJzeo/K9pjMAIRLwuIAbjdAG6ycRiuAH/yQTUc8HQBgDeroRAM5LSuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MY.png
// module id = 1221
// module chunks = 0